import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/utils.js';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';
type Size = 'sm' | 'md' | 'lg';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  children: ReactNode;
}

const variantClasses: Record<Variant, string> = {
  primary: 'bg-[var(--ac-accent)] text-white hover:opacity-90 disabled:opacity-50',
  secondary:
    'bg-[var(--ac-surface-elevated)] text-[var(--ac-text)] border border-[var(--ac-border)] hover:bg-[var(--ac-surface)] disabled:opacity-50',
  ghost:
    'bg-transparent text-[var(--ac-text)] hover:bg-[var(--ac-surface-elevated)] disabled:opacity-50',
  danger: 'bg-[var(--ac-error)] text-white hover:opacity-90 disabled:opacity-50',
};

const sizeClasses: Record<Size, string> = {
  sm: 'px-2 py-1 text-sm',
  md: 'px-4 py-2 text-base',
  lg: 'px-6 py-3 text-lg',
};

export function Button({
  variant = 'primary',
  size = 'md',
  className,
  children,
  ...rest
}: ButtonProps) {
  return (
    <button
      {...rest}
      className={cn(
        'inline-flex items-center justify-center gap-2 rounded-lg font-medium transition-colors',
        variantClasses[variant],
        sizeClasses[size],
        className,
      )}
    >
      {children}
    </button>
  );
}
